module.exports = __webpack_public_path__ + "img/f8799d2.png";